module.exports = __webpack_public_path__ + "img/mz.46213edf.jpg";